import { Col, Row, Tag, Typography } from 'antd';
import React from 'react';
import 'moment/locale/pt-br';
import i18next from 'i18next';

const normalizeActions = (action) => {
  switch (action) {
    case 'POST':
      return <Tag color="green">CRIADO</Tag>;
    case 'PUT':
      return <Tag color="blue">ATUALIZADO</Tag>;
    case 'DELETE':
      return <Tag color="red">DELETADO</Tag>;
    default:
      return '';
  }
};

const normalizeClasses = (classes) => {
  switch (classes) {
    case 'Events':
      return <Tag>EVENTO</Tag>;
    case 'EventFinancials':
      return <Tag>FECHAMENTO FINANCEIRO</Tag>;
    case 'Sectors':
      return <Tag>SETORES</Tag>;
    case 'EventServices':
      return <Tag>SERVIÇOS</Tag>;
    case 'EventExpenses':
      return <Tag>DESPESAS EXTRA</Tag>;
    case 'TeamsEmployees':
      return <Tag>EQUIPE</Tag>;
    case 'Consigneds':
      return <Tag>ITENS</Tag>;
    default:
      return '';
  }
};

export const activityLogsColumns = () => {
  return [
    {
      title: i18next.t('Ação'),
      dataIndex: 'action',
      key: 'action',
      render: (text, _) => normalizeActions(text),
    },
    {
      title: i18next.t('Responsável'),
      dataIndex: 'user_name',
      key: 'user_name',
    },
    {
      title: i18next.t('Onde'),
      dataIndex: 'class',
      key: 'class',
      render: (text, _) => normalizeClasses(text),
    },
    {
      title: i18next.t('Quando'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, _) => text,
    },
  ];
};

export const activityLogsExpanded = (record) => {
  const oldValue = record.old_value && typeof record.old_value === 'object' ? record.old_value : {};
  const newValue = record.new_value && typeof record.new_value === 'object' ? record.new_value : {};
  const keys = [...new Set([...Object.keys(oldValue), ...Object.keys(newValue)])];

  return (
    <div style={{ padding: '16px', background: '#fafafa' }}>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Typography.Text strong>Valores Antigos</Typography.Text>
          {keys.length > 0 ? (
            <ul>
              {keys.map((key) => (
                <li key={key}>
                  <Typography.Text strong>{key}: </Typography.Text>
                  {oldValue[key] !== undefined && oldValue[key] !== null ? oldValue[key] : 'N/A'}
                </li>
              ))}
            </ul>
          ) : (
            <Typography.Text type="secondary">Nenhum valor antigo disponível</Typography.Text>
          )}
        </Col>
        <Col span={12}>
          <Typography.Text strong>Novos Valores</Typography.Text>
          {keys.length > 0 ? (
            <ul>
              {keys.map((key) => (
                <li key={key}>
                  <Typography.Text strong>{key}: </Typography.Text>
                  {newValue[key] !== undefined && newValue[key] !== null ? newValue[key] : 'N/A'}
                </li>
              ))}
            </ul>
          ) : (
            <Typography.Text type="secondary">Nenhum valor novo disponível</Typography.Text>
          )}
        </Col>
      </Row>
    </div>
  );
};
